import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=afbb25ba&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbb25ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afbb25ba')) {
      api.createRecord('afbb25ba', component.options)
    } else {
      api.reload('afbb25ba', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=afbb25ba&scoped=true&", function () {
      api.rerender('afbb25ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2euXTcGnVa99s/JS/comp/SearchFilterTokens.vue"
export default component.exports